import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyDn2U-OaLVW8zO-n5iFzKPqWPO-30g_3Lo",
  authDomain: "mia-app-76836.firebaseapp.com",
  projectId: "mia-app-76836",
  storageBucket: "mia-app-76836.firebasestorage.app",
  messagingSenderId: "315797960402",
  appId: "1:315797960402:web:a62d8243176618ee4cdf0b",
  measurementId: "G-XV52350YJD"
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const auth = getAuth(app);
export default app;